module.exports = __webpack_public_path__ + "static/cbi_logo-6181553f811918862a0e9a994ec9013e.png";